// src/translations/en.js
const en = {
  header: {
    home: 'Home',
    services: 'Services',
    aboutUs: 'About Us',
    contact: 'Contact',
  },

  footer: {
    contactUs: 'Contact Us',
    quickLinks: 'Quick Links',
    ourMission: 'Our Mission',
    missionText:
      'Empowering individuals and businesses through comprehensive financial solutions.',
    allRightsReserved: 'All rights reserved.',
    followUs: 'Follow Us',
    legal: 'Legal',
    privacyPolicyEs: 'Privacy Policy (ES)',
    privacyPolicyEn: 'Privacy Policy (EN)',
    doNotSellShare: 'Do Not Sell/Share',
    limitSensitiveData: 'Limit Sensitive Data',
    privacyRequest: 'Privacy Request',
  },

  home: {
    hero: {
      title: 'Your Path to Financial Success Starts Here',
      subtitle:
        'Empowering individuals and businesses with comprehensive financial solutions for growth and stability.',
      button: 'Get Started Today',
      businessPlanButton: 'View Our Solutions',
    },
    services: {
      title: 'Our Core Services',
      corporateTaxes: {
        title: 'Corporate & LLC Taxes',
        description:
          'Strategic preparation of Forms 1120, 1120-S and 1065, with amendments, extensions and year-round support to protect your company in front of the IRS.',
      },
      personalTaxes: {
        title: 'Personal & Small Business Taxes',
        description:
          '1040 returns, amendments, extensions, ITIN (W-7) and IRS letters explained in plain language so you can file with confidence and avoid surprises.',
      },
      businessCreditProfile: {
        title: 'Business Credit Profile',
        description:
          'We build with you a business credit profile the system can actually see: DUNS, vendor accounts that report and a professional presence that opens doors.',
      },
      capitalMap: {
        title: 'Capital Map',
        description:
          'We analyze your numbers and structure to design 2–3 real capital routes for your company, aligned with your current reality and growth goals.',
      },
      financialEducation: {
        title: 'Financial Education for Loans',
        description:
          'We teach you how lenders think so you stop applying blindly and start requesting capital with a clear strategy and solid numbers.',
      },
      businessRegistration: {
        title: 'Business Registration',
        description: 'Formalize your business for growth and legal benefits.',
      },
      businessFinancing: {
        title: 'Business Financing',
        description: 'Access capital to fuel your business expansion.',
      },
      microcredits: {
        title: 'Microcredits',
        description:
          'Flexible loans for personal needs or small business boosts.',
      },
    },
    problems: {
      title: 'Real Solutions for Real Challenges',
      capitalLack: {
        title: 'Lack of Capital for Growth',
        description:
          'Need to invest in advertising or staff? We help you secure the loans to triple your sales and achieve profitability.',
      },
      informalBusiness: {
        title: 'Informal Business Operations',
        description:
          'Operating as a freelancer? We provide microcredits to cover legal registration, licenses, and advisory, formalizing your business in less than 15 days.',
      },
      substandardPremises: {
        title: 'Substandard Business Premises',
        description:
          'Your physical store needs an upgrade? Our real estate financing or business microcredits can fund renovations, increasing customer traffic by 60%.',
      },
      insufficientCashFlow: {
        title: 'Insufficient Cash Flow',
        description:
          'Orders piling up but no cash for inventory or payroll? Our revolving credit lines ensure your operations never stop, keeping customers satisfied.',
      },
    },
    cta: {
      title: 'Ready to Transform Your Financial Future?',
      subtitle:
        "Don't let financial hurdles hold you back. Contact us today for a personalized plan and clear solutions.",
      button: 'Contact Us Now',
    },
  },

  services: {
    hero: {
      title: 'Our Comprehensive Financial Solutions',
      subtitle:
        'Empowering your financial journey with tailored services designed for success and stability.',
    },
  },

  // 🔥🔥🔥 ADDED — PACKAGES & PRICING SECTION 🔥🔥🔥
  pricing: {
    title: 'Packages & Pricing',
    subtitle: '12-month Fractional CFO program for entrepreneurs and small businesses.',
    plans: {
      starter: {
        badge: 'Starter Plan',
        price: '$3,500',
        per: '/year',
        forTitle: 'Designed for:',
        forText: 'New entrepreneurs or early-stage businesses.',
        objectiveTitle: 'Objective:',
        objectiveText: 'Establish financial structure and business presence.',
        includesTitle: 'Includes:',
        includes: [
          'Basic business formalization support',
          'Initial business credit setup',
          'Basic business profile (website, corporate email and phone)',
          'Taxes: Form 1040 + Schedule C + extensions + state return if applicable',
          'Financial education & support (monthly)'
        ],
        resultsTitle: 'Expected results:',
        results: [
          'Structured business presence',
          'Initial PAYDEX development',
          'Foundation for future funding'
        ]
      },
      growth: {
        badge: 'Growth Plan',
        price: '$5,500',
        per: '/year',
        forTitle: 'Designed for:',
        forText: 'Businesses generating revenue needing financial and tax organization.',
        objectiveTitle: 'Objective:',
        objectiveText: 'Organize bookkeeping, reporting and tax strategy.',
        includesTitle: 'Includes everything in Starter, plus:',
        includes: [
          'Monthly bookkeeping (QuickBooks)',
          'Profit & Loss, Balance Sheet and basic Cash Flow reports',
          'Basic tax planning and deduction optimization',
          'Business credit expansion and PAYDEX monitoring'
        ],
        resultsTitle: 'Expected results:',
        results: [
          'Owner understands business numbers',
          'Optimized tax burden (legal)',
          'Reports ready for capital applications'
        ]
      },
      expansion: {
        badge: 'Expansion Plan',
        price: '$7,500',
        per: '/year',
        forTitle: 'Designed for:',
        forText: 'Businesses seeking scalability and access to capital.',
        objectiveTitle: 'Objective:',
        objectiveText: 'Prepare business for commercial financing and growth.',
        includesTitle: 'Includes everything in Growth, plus:',
        includes: [
          'Capital Map (2–3 funding routes)',
          'Pre-underwriting for banks & SBA',
          'Bank-ready package & projections',
          'Owner compensation and advanced tax strategy',
          'Business credit management to build credit history'
        ],
        resultsTitle: 'Expected results:',
        results: [
          'Eligibility for commercial capital',
          'Scalable financial structure',
          'Improved negotiation power with lenders'
        ]
      }
    }
  },

  about: {
    hero: {
      title: 'About San Jose Obrero LLC',
      subtitle:
        'Your trusted partner in financial empowerment and sustainable growth.',
    },
  },

  contact: {
    hero: {
      title: 'Get in Touch',
      subtitle:
        "We're here to help you achieve your financial goals. Reach out to us today!",
    },
  },

  whatsapp: {
    defaultMessage:
      'Hello, I would like to know more about your financial services.',
  },
};

export default en;
